module.exports = __webpack_public_path__ + "static/org_pri-0e03f5c5840246e9da1f1fa825f89c02.png";